// External
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

// Internal
import { ValuesService } from '../../values/values.service';
import { SubscriptionsService } from '../process/subscriptions/subscriptions.service';

@Injectable({ providedIn: 'root' })

export class RedirectNccGuard {

    constructor(
        private readonly router: Router,
        private readonly subscriptionsService: SubscriptionsService,
        private readonly valuesService: ValuesService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const hasSubscription = this.subscriptionsService.hasParentalNCC();
        if (!hasSubscription) {
            this.router.navigate([this.valuesService.centralPaths.parentalncc.path], { replaceUrl: true });
            return false;
        }
        return true;
    }
}